var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OTC---Mobile-Dashboard-1",
    transform: "translate(-304.000000, -736.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 722.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(23.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(254.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-20px-activity",
    transform: "translate(27.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.35949657,7.07842877 L4.99167979,10.3824987 C4.83694566,10.7562713 4.47225878,11 4.06772377,11 L1,11 C0.44771525,11 -9.30505493e-14,10.5522847 -6.39488462e-14,10 C-3.48471432e-14,9.44771525 0.44771525,9 1,9 L3.39940053,9 L5.62764394,3.61750127 C5.99197483,2.73743112 7.26384858,2.81679994 7.51594087,3.73533679 L10.196161,13.501129 L12.6758902,5.80490027 C12.9336465,5.00491319 14.0034314,4.86047708 14.4641106,5.56346518 L16.7161263,9 L19,9 C19.5522847,9 20,9.44771525 20,10 C20,10.5522847 19.5522847,11 19,11 L16.1758507,11 C15.8386974,11 15.5242417,10.8301073 15.3394446,10.5481102 L13.937951,8.40945658 L11.0712622,17.3066751 C10.7664938,18.2525715 9.41812467,18.2230084 9.155107,17.2646632 L6.35949657,7.07842877 Z",
    id: "Line-31"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivity);
export default __webpack_public_path__ + "static/media/icon-activity.918fee6d9577d5675db6ace117690e7b.svg";
export { ForwardRef as ReactComponent };